import PropTypes from 'prop-types';
import { ReactComponent as PollBackgroundImage } from "./icons/PollBackgroundImage.svg";
import { Box } from '@mui/material';


const ManagePollStep = ({ step, activeStep }) => {

    if (step !== activeStep) {
        return null;
    }

    return <Box display={'flex'} flexGrow={1} justifyContent={'center'}>
        <PollBackgroundImage style={{ maxWidth: 500, width: 500 }} />
    </Box>;
}

ManagePollStep.propTypes = {
    step: PropTypes.number,
    activeStep: PropTypes.number
}
export default ManagePollStep;